import moment from 'moment';
import DTO from './DTO';
import IndividualEntrepreneurDTO from './IndividualEntrepreneurDTO';
import JuridicalDTO from './JuridicalDTO';
import InsurerDTO from './InsurerDTO';
import { required } from '../utils/validation';
import { PROCEDURE_TYPE, USER_TYPE } from '../configs';

class CarrierDTO extends DTO {
  constructor(params, isValidInit) {
    const ipAttr = new IndividualEntrepreneurDTO().getAttributes();
    const legalAttr = new JuridicalDTO().getAttributes();
    const insurerAttr = new InsurerDTO().getAttributes();
    const attributes = [
      {
        name: 'view_mode',
        type: String,
        validators: {},
        labelKey: 'view_mode',
      },
      {
        name: 'id',
        type: String,
        validators: [],
        labelKey: 'id',
      },
      {
        name: 'legal_entity_type',
        type: Number,
        validators: [],
        labelKey: 'legal_entity_type',
      },
      ...ipAttr,
      ...legalAttr,
      ...insurerAttr,
      {
        name: 'number',
        type: String,
        validators: [],
        labelKey: 'registry.number',
      },
      {
        name: 'order_service_number',
        type: String,
        validators: [],
        labelKey: 'registry.number',
      },
      {
        name: 'order_services_attach_order_service_number',
        type: String,
        validators: [],
        labelKey: 'registry.number',
      },
      {
        name: 'contract_number',
        type: String,
        validators: [],
        labelKey: 'order_service_contract_number',
      },
      {
        name: 'order_service_contract_number',
        type: String,
        validators: [],
        labelKey: 'order_service_contract_number',
      },
      {
        name: 'effective_date',
        type: moment,
        validators: [required],
        labelKey: 'effective_date',
      },
      {
        name: 'expiration_date',
        type: moment,
        validators: [required],
        labelKey: 'expiration_date',
      },
      {
        name: 'permission_grant_period',
        type: moment,
        validators: [],
        labelKey: 'permission_grant_period',
      },
      {
        name: 'status',
        type: String,
        validators: [],
        labelKey: 'status',
      },
      {
        name: 'created_at',
        type: moment,
        validators: [],
        labelKey: 'created_at',
      },
      {
        name: 'driver_license_files',
        type: String,
        validators: [required],
        labelKey: 'media.driver_license_files',
      },
      {
        name: 'driver_license_series',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON && !params?.optional ? [required] : [],
        labelKey: 'driver_license_series',
      },
      {
        name: 'driver_license_number',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON && !params?.optional ? [required] : [],
        labelKey: 'driver_license_number',
      },
      {
        name: 'driver_license_issue_date',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON && !params?.optional ? [required] : [],
        labelKey: 'driver_license_issue_date',
      },
      {
        name: 'driver_license_expiration_date',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON ? [] : [],
        labelKey: 'driver_license_expiration_date',
      },
      {
        name: 'medical_examination_address',
        type: String,
        validators: [],
        labelKey: 'medical_examination_address',
      },
      {
        name: 'commercial_name',
        type: String,
        validators: [],
        labelKey: 'commercial_name',
      },
      {
        name: 'logo_files',
        type: String,
        validators: [],
        labelKey: 'logo_files',
      },
      {
        name: 'carriage_file',
        type: String,
        validators: [],
        labelKey: 'carriage_file',
      },
      {
        name: 'insurer',
        type: String,
        validators: [],
        labelKey: 'insurer',
      },
      {
        name: 'insurance_contract_number',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_number',
      },
      {
        name: 'insurance_contract_effective_date',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_effective_date',
      },
      {
        name: 'insurance_contract_expiration_date',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_expiration_date',
      },
      {
        name: 'carriage_contract_number',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON && !params?.optional ? [required] : [],
        labelKey: 'carriage_contract_number',
      },
      {
        name: 'carriage_contract_effective_date',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON && !params?.optional ? [required] : [],
        labelKey: 'carriage_contract_effective_date',
      },
      {
        name: 'carriage_contract_expiration_date',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON && !params?.optional ? [required] : [],
        labelKey: 'carriage_contract_expiration_date',
      },
      {
        name: 'has_employees',
        type: Boolean,
        validators: [],
        labelKey: 'has_employees',
      },
      {
        name: 'medical_examination_address',
        type: String,
        validators: [],
        labelKey: 'medical_examination_address',
      },
      {
        name: 'criminal_record_certificate_info_doc',
        type: String,
        validators: [required],
        labelKey: 'media.criminal_record_certificate_info_doc',
        couldBeNull: true,
      },
      {
        name: 'criminal_record_note',
        type: String,
        validators: [],
        labelKey: 'criminal_record_note',
      },
      {
        name: 'decision',
        type: String,
        validators: [required],
        labelKey: 'decision',
      },
      {
        name: 'decision_date',
        type: String,
        validators: [required],
        labelKey: 'decision_date',
      },
      {
        name: 'order_service_ogrn',
        type: String,
        validators: [],
        labelKey: 'order_service_ogrn',
      },
      {
        name: 'order_service_id',
        type: String,
        validators: [],
        labelKey: 'order_service_id',
      },
      {
        name: 'order_service_contract_files',
        type: String,
        validators: [required],
        labelKey: 'media.order_service_contract_files',
      },
      {
        name: 'order_service_contract_number',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON || [PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_1].includes(params?.procedure) ? [required] : [],
        labelKey: 'order_service_contract_number',
      },
      {
        name: 'contract_number',
        type: String,
        validators: [],
        labelKey: 'order_service_contract_number',
      },
      {
        name: 'order_service_contract_effective_date',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON || [PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_1].includes(params?.procedure) ? [required] : [],
        labelKey: 'order_service_contract_effective_date',
      },
      {
        name: 'contract_effective_date',
        type: String,
        validators: [],
        labelKey: 'order_service_contract_effective_date',
      },
      {
        name: 'order_service_contract_effective_date',
        type: String,
        validators: [],
        labelKey: 'order_service_contract_effective_date',
      },
      {
        name: 'order_service_contract_expiration_date',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON || [PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_1].includes(params?.procedure) ? [required] : [],
        labelKey: 'order_service_contract_expiration_date',
      },
      {
        name: 'contract_expiration_date',
        type: String,
        validators: [],
        labelKey: 'order_service_contract_expiration_date',
      },
      {
        name: 'order_service_contract_expiration_date',
        type: String,
        validators: [],
        labelKey: 'order_service_contract_expiration_date',
      },
      {
        name: 'vehicle_ids',
        type: String,
        validators: [],
        labelKey: 'vehicle_ids',
      },
      {
        name: 'vehicle_numbers_attach',
        type: String,
        validators: [required],
        labelKey: 'vehicle_numbers_attach',
      },
      {
        name: 'vehicle_numbers_detach',
        type: String,
        validators: [],
        labelKey: 'vehicle_numbers_detach',
      },
      {
        name: 'vehicles_attach',
        type: String,
        validators: [required],
        labelKey: 'vehicle_numbers_attach',
      },
      {
        name: 'vehicles_detach',
        type: String,
        validators: [],
        labelKey: 'vehicle_numbers_detach',
      },
      {
        name: 'order_service_numbers',
        type: String,
        validators: [],
        labelKey: 'order_service_numbers',
      },
      {
        name: 'order_service_number',
        type: String,
        validators: [],
        labelKey: 'order_service_numbers_detach',
      },
      {
        name: 'order_service_numbers_detach',
        type: String,
        validators: [],
        labelKey: 'order_service_numbers_detach',
      },
      {
        name: 'carriage_contract_name',
        type: String,
        validators: [],
        labelKey: 'carriage_contract_name',
      },
      {
        name: 'carriage_vehicle_number',
        type: String,
        validators: [],
        labelKey: 'vehicle.registry.number',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default CarrierDTO;
